var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Rate Matrix",
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "width": "1600px",
      "top": "2vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "mb10 contentHead"
  }, [_c('span', [_vm._v("Month:")]), _vm.dataRow.month ? [_vm._v(" " + _vm._s(_vm.dataRow.month.slice(0, 4) + "-" + _vm.dataRow.month.slice(4)) + " ")] : _vm._e()], 2), _c('el-table', {
    staticClass: "wdb100",
    attrs: {
      "tooltip-effect": "dark",
      "size": "mini",
      "fit": "",
      "data": _vm.dataList,
      "height": "80vh"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Currency",
      "header-align": "center",
      "align": "left",
      "width": "130",
      "fixed": "left",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.currency))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Code",
      "align": "center",
      "width": "60",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.code))])];
      }
    }])
  }), _vm._l(_vm.exRateCurrencyExclusiveList, function (item) {
    return _c('el-table-column', {
      key: "rate-matrix-".concat(item.currency),
      attrs: {
        "label": item.currency,
        "align": "center",
        "min-width": "94"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(scope) {
          return [_c('span', {
            class: {
              bgGray: Number(scope.row[item.currency]) == 1
            }
          }, [_vm._v(_vm._s(scope.row[item.currency]))])];
        }
      }], null, true)
    });
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }